import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZMaster4A: IAbstractModule = {
  type: IModuleType.masterZ4,
  name: 'Z Master 4 A (1-4)',
  hasScreen: true,
  columns: [
    [
      {
        name: "1",
        connector: "1",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "2",
        connector: "2",
        cell_size_id: 2,
        accessible: true,
      },
      {
        name: "3",
        connector: "3",
        cell_size_id: 4,
        accessible: true,
      },
      {
        name: "4",
        connector: "4",
        cell_size_id: 4,
        accessible: false,
      },
    ],
  ]
};
